import {
  Elements,
  PaymentMethodMessagingElement,
} from "@stripe/react-stripe-js";
import { StripePaymentMethodMessagingElementOptions } from "@stripe/stripe-js";
import { useRouter } from "next/router";

import { useAppContext } from "components/store/source";
import { useMedia } from "components/ui/source";

import { useChargebud } from "services/chargebud/chargebudContext";

import stripeElementsTheme from "./theme";

const supportedCurrencies = [
  "USD",
  "GBP",
  "EUR",
  "DKK",
  "NOK",
  "SEK",
  "AUD",
  "CAD",
  "NZD",
];

const supportedCountryCodes = [
  "US",
  "GB",
  "CA",
  "AU",
  "NZ",
  "IE",
  "FR",
  "ES",
  "DE",
  "AT",
  "BE",
  "DK",
  "FI",
  "IT",
  "NL",
  "NO",
  "SE",
];

type Props = Pick<StripePaymentMethodMessagingElementOptions, "amount"> & {
  className: string;
};

const PaymentMethodMessaging = ({ amount, className }: Props) => {
  const { stripePromise } = useChargebud();
  const { currency: contextCurrency } = useAppContext();
  const { locale } = useRouter();
  const isMobile = useMedia(["$mobile-lg"], [true], false);

  const rules = {
    ".PaymentMethodMessaging": {
      textAlign: isMobile ? "left" : "right",
    },
  };

  const currency = supportedCurrencies.includes(contextCurrency)
    ? (contextCurrency as StripePaymentMethodMessagingElementOptions["currency"])
    : "USD";

  const currentCountryCode = locale.split("-")[1].toUpperCase();
  const countryCode = supportedCountryCodes.includes(currentCountryCode)
    ? (currentCountryCode as StripePaymentMethodMessagingElementOptions["countryCode"])
    : "US";

  if (!stripePromise) return null;

  return (
    <Elements
      stripe={stripePromise}
      options={{
        appearance: {
          ...stripeElementsTheme,
          rules,
        },
      }}
    >
      <div className={className}>
        <PaymentMethodMessagingElement
          options={{
            amount,
            currency,
            paymentMethodTypes: ["klarna", "affirm"],
            countryCode,
          }}
        />
      </div>
    </Elements>
  );
};

export default PaymentMethodMessaging;
